export const SERVICE_COLOR_PALETTE = [
  { name: "Peacock", hex: "#039be5" },
  { name: "Blueberry", hex: "#3f51b5" },
  { name: "Lavanda", hex: "#7986cb" },
  { name: "Grape", hex: "#8e24aa" },
  { name: "Flamingo", hex: "#e67c73" },
  { name: "Tomate", hex: "#d50000" },
  { name: "Tangerina", hex: "#f4511e" },
  { name: "Banana", hex: "#f6bf26" },
  { name: "Sage", hex: "#33b679" },
  { name: "Manjericão", hex: "#0b8043" },
  { name: "Grafite", hex: "#616161" },
];

export const DEFAULT_SERVICE_COLOR = SERVICE_COLOR_PALETTE[0].hex;
